import { settleApiCall } from '../api/utils';
import { getAllItemsPriceVariants } from '../utils/priceVariants';
import { getAllItemsLabels } from '../utils/labels';
import { convertPopulatedItemToItemDTO } from '../utils/converters';
import { getAllItemsModifierGroups } from '../utils/modifierGroups';
import { buildDuplicatedPopulatedItem, getItemsToDuplicate } from './utils/duplicateItems.utils';
import { createFieldToEntityMap } from '../utils/common';
export const duplicateItems = async _ref => {
  let {
    items,
    duplicatedNameCreator,
    itemsClient,
    populationLevel,
    source
  } = _ref;
  const {
    itemsToDuplicate
  } = getItemsToDuplicate({
    items,
    duplicatedNameCreator
  });
  const modifierGroups = getAllItemsModifierGroups(itemsToDuplicate);
  const idsToModifierGroupsMap = createFieldToEntityMap(modifierGroups, 'id');
  const priceVariants = getAllItemsPriceVariants(items, populationLevel);
  const idsToPriceVariantsMap = populationLevel != null && populationLevel.priceVariants ? createFieldToEntityMap(priceVariants, 'id') : createFieldToEntityMap(priceVariants, 'variantId');
  const labels = getAllItemsLabels(items, populationLevel);
  const idsToLabelsMap = createFieldToEntityMap(labels, 'id');
  const itemsToDuplicateInDTOForm = itemsToDuplicate.map(item => convertPopulatedItemToItemDTO(item, !!item.priceVariants, populationLevel));
  const bulkCreateItemsResponse = await settleApiCall(() => itemsClient.bulkCreate(itemsToDuplicateInDTOForm, source));
  if (bulkCreateItemsResponse.hasError) {
    return bulkCreateItemsResponse;
  }
  const duplicatedItemsInPopulatedForm = bulkCreateItemsResponse.data.map(item => buildDuplicatedPopulatedItem(item, idsToPriceVariantsMap, idsToLabelsMap, idsToModifierGroupsMap, populationLevel));
  return {
    data: duplicatedItemsInPopulatedForm,
    hasError: false
  };
};
//# sourceMappingURL=duplicateItems.js.map